import React from 'react';
import { GameType } from '../GameType';
import { OpensInXTime } from '../OpensInXTime';

export const GameSpecificFields = ({ gameInfo, showGradient }) => {
    let gameSpecificFields = <GameType gameInfo={gameInfo} showGradient={showGradient}/>;

    if (gameInfo.open === false) {
        gameSpecificFields = <OpensInXTime
            startTime={gameInfo.startTime}
            showGradient={showGradient}
        />;
    }

    return <div className="live-casino">{gameSpecificFields}</div>;
};
